import { render, staticRenderFns } from "./BroadcastDetails.vue?vue&type=template&id=066f2565&scoped=true"
import script from "./BroadcastDetails.vue?vue&type=script&lang=js"
export * from "./BroadcastDetails.vue?vue&type=script&lang=js"
import style0 from "./BroadcastDetails.vue?vue&type=style&index=0&id=066f2565&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "066f2565",
  null
  
)

export default component.exports